<template>
  <div>
    <el-dialog :title="title ? title : '准入考核'" :before-close="handleClose" width="1200px"
      :visible.sync="showadmissionExamination" class="examination" :close-on-click-modal="false"
      :modal-append-to-body='false' :append-to-body="true" top='100px' center>


      <el-table border :data='tableData'>
        <el-table-column prop="totalScore" label="总分" align="center">
        </el-table-column>
        <el-table-column prop="passScore" label="合格分数线" align="center">
        </el-table-column>
        <el-table-column prop="Score" label="你的分数" align="center">
        </el-table-column>
      </el-table>
      <div class='examinationBox'>
        <div class='examinationTitle'>{{ testPaperName }}</div>
        <div class='questionBox'>
          <div v-for='(items, indexs) in showData' :key='indexs' class='bigex'>
            <div class='exTitle'>
              {{ items.subjectName + '(共' + items.subjectNumber + '题' + items.subjectScore + '分)' }}
            </div>
            <div v-for='(item, index) in items.extendedData' :key='index' class='smallexbox'>
              <div v-if="item.questionType == '单选' || item.questionType == '判断'">
                <div class='smallexTitle'>
                  {{ (index + 1) + '.(' + item.questionType + ')' + item.questionContent }}
                  <div style='color:#009943' v-if='ifPass'><span>答案：</span>{{ item.needResult }}</div>
                </div>
                <div v-for='(itemsmall, indexsm) in item.list' :key='indexsm' class='exContent'>

                  <el-radio v-model="item.radio" :disabled='ifPass' :label="itemsmall.uuid">{{ itemsmall.radio + '.' +
                    itemsmall.content }}</el-radio>
                </div>
              </div>
              <div v-if="item.questionType == '多选'">
                <div class='smallexTitle'>
                  {{ (index + 1) + '.(' + item.questionType + ')' + item.questionContent }}
                  <div style='color:#009943' v-if='ifPass'><span>答案：</span>{{ item.needResult }}</div>
                </div>
                <div v-for='(itemsmall, indexsm) in item.list' :key='indexsm' class='exContent'>
                  <el-checkbox :disabled='ifPass' v-model="itemsmall.selectResult">{{ itemsmall.radio + '.' +
                    itemsmall.content }}</el-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer">
        <el-button type="primary" v-if='!ifPass' @click="detail_save">交卷</el-button>
        <el-button v-if='!ifPass' @click="handleClose">取消</el-button>
        <el-button @click="handleClose" v-if='ifPass'>返回</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    showadmissionExamination: {
      type: Boolean,
      default: false
    },
    title: {
      default: false
    },
    eqId: {
      default: false
    }
  },
  data() {
    return {
      firstData: {},
      showData: [],
      tableData: [{ totalScore: '', passScore: '', Score: '' }],
      ifPass: false,
      testPaperName: ''
    }
  },
  methods: {
    init() {
      let url = this.eqId ? `/sdau/userClient/appraisal/queryExamPaperById/${this.eqId}` : `/sdau/userClient/appraisal/queryAdmissionExamPaper`
      this.$net(url, 'get').then(res => {
        this.ifPass = res.data.pass
        this.firstData = this.ifPass ? res.data.appraisalTestPaperResult : res.data.appraisalTestPaper
        this.testPaperName = this.firstData.testPaperName
        this.tableData[0].Score = this.ifPass ? res.data.appraisalTestPaperResult.achievement : ''
        this.showData = JSON.parse(JSON.stringify(this.firstData.subjectList))
        this.showData.forEach(item => {
          item.extendedData = JSON.parse(item.extendedData)
        })
        this.showData.forEach((item1, index1) => {
          item1.extendedData.forEach((item2, index2) => {
            this.$set(this.showData[index1].extendedData[index2], 'resultquest', [])
            this.showData[index1].extendedData[index2].list.forEach((item, index) => {
              if (this.showData[index1].extendedData[index2].list[index].selectQuest) {
                this.showData[index1].extendedData[index2].resultquest.push(this.showData[index1].extendedData[index2].list[index].radio)
              }
            })
            this.$set(this.showData[index1].extendedData[index2], 'needResult', this.showData[index1].extendedData[index2].resultquest.join(','))

          })
        })
        this.tableData[0].totalScore = res.data.appraisalTestPaper.totalScore
        this.tableData[0].passScore = res.data.appraisalTestPaper.passScore
      })
    },
    handleClose() {
      this.$emit('close')
    },
    detail_save() {
      this.firstData.subjectList = JSON.parse(JSON.stringify(this.showData))
      this.firstData.subjectList.forEach((bigitem, indexbg) => {
        bigitem.extendedData.forEach((item, index) => {
          if (bigitem.extendedData[index].questionType == '单选' || bigitem.extendedData[index].questionType == '判断') {
            this.showData[indexbg].extendedData[index].list.forEach((itemsmall, indexs) => {
              if (item.radio == itemsmall.uuid) {
                this.$set(this.firstData.subjectList[indexbg].extendedData[index].list[indexs], 'selectResult', true)
              }
            })
          }
        })
      })
      this.firstData.subjectList.forEach((bigitemS, indexbgS) => {
        this.$set(this.firstData.subjectList[indexbgS], 'appraisalTestPaperSubjectId', this.firstData.subjectList[indexbgS].id)
        this.firstData.subjectList[indexbgS].extendedData = JSON.stringify(this.firstData.subjectList[indexbgS].extendedData)
      })
      this.$set(this.firstData, 'appraisalTestPaperId', this.firstData.id)
      this.$net(`/sdau/userClient/appraisal/answer`, 'post', this.firstData).then(res => {
        this.tableData[0].Score = res.data.score
        this.ifPass = res.data.pass
        if (this.ifPass) {
          this.$message({
            type: 'success',
            message: this.tableData[0].Score + '分,考试通过'
          })
          this.handleClose()
        }
        else {
          this.$message({
            type: 'warning',
            message: this.tableData[0].Score + '分,考试未通过'
          })
          this.init()
        }
      })
    },
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
::v-deep.examination {
  .el-dialog__header {
    border-bottom: 1px #d7dce0 solid;
    padding: 0 0;
    height: 56px;
    line-height: 56px;
    font-weight: 800;
    color: black;
    // color: rgb(76, 110, 184);

    .el-dialog__headerbtn {
      top: 16px;
      right: 16px;

      .el-dialog__close {
        font-size: 24px;
      }
    }
  }

  .el-table {
    width: 22%;
    position: absolute;
    right: 40px;
    top: 70px;

    thead tr th {
      font-size: 12px;
      font-weight: normal;
    }
  }
}

::v-deep.examinationBox {
  padding: 16px 32px 32px 32px;

  .examinationTitle {
    text-align: center;
    font-size: 20px;
    font-weight: 800;
    color: #000;
  }

  .questionBox {
    margin-top: 32px;
    max-height: 500px;
    overflow: auto;

    .bigex {
      .exTitle {
        font-size: 18px;
        font-weight: 600;
        color: #000;
        margin-bottom: 8px;
        margin-top: 16px;
      }

      .smallexbox {
        padding-left: 16px;

        .smallexTitle {
          font-size: 16px;
          color: #000;
          margin-bottom: 8px;
          margin-top: 8px;
        }

        .exContent {
          margin-bottom: 4px;
          padding-left: 4px;
        }
      }
    }
  }
}
</style>